import { paginatedField } from "@/v2-backoffice-client/components/table"

// Infinite-scroll cache policy for the sessions list. Reuses the shared
// append-on-offset merge but keys on the typed input filters (this query
// carries search/status as top-level input fields, not the generic
// sort/filters/filterTree shape paginatedField defaults to), so each
// search/status combination is its own list and successive pages append.
export const userLoginCacheFields = {
  getUserLogins: {
    ...paginatedField(),
    keyArgs: ["input", ["search", "status", "userId"]],
  },
}
